export enum AuditStatus {
  Draft = 0,
  Submitted = 3,
}

export const getAuditStatusLabel = (status: AuditStatus): string => {
  switch (status) {
    case AuditStatus.Draft:
      return 'Draft';
    case AuditStatus.Submitted:
      return 'Submitted';
    default:
      return 'Unknown';
  }
};

export const getAuditStatusColor = (status: AuditStatus): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  switch (status) {
    case AuditStatus.Draft:
      return 'default';
    case AuditStatus.Submitted:
      return 'success';
    default:
      return 'default';
  }
};

export enum TrainingStatus {
  Draft = 0,
  Published = 1,
  Archived = 2,
  Assigned = 3,
  InProgress = 4,
  Completed = 5,
  Failed = 6,
  Expired = 7,
}

export const getTrainingStatusLabel = (status: TrainingStatus): string => {
  switch (status) {
    case TrainingStatus.Draft:
      return 'Draft';
    case TrainingStatus.Published:
      return 'Published';
    case TrainingStatus.Archived:
      return 'Archived';
    case TrainingStatus.Assigned:
      return 'Assigned';
    case TrainingStatus.InProgress:
      return 'In Progress';
    case TrainingStatus.Completed:
      return 'Completed';
    case TrainingStatus.Failed:
      return 'Failed';
    case TrainingStatus.Expired:
      return 'Expired';
    default:
      return 'Unknown';
  }
};

export const getTrainingStatusColor = (status: TrainingStatus): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  switch (status) {
    case TrainingStatus.Draft:
      return 'default';
    case TrainingStatus.Published:
      return 'primary';
    case TrainingStatus.Archived:
      return 'default';
    case TrainingStatus.Assigned:
      return 'warning';
    case TrainingStatus.InProgress:
      return 'info';
    case TrainingStatus.Completed:
      return 'success';
    case TrainingStatus.Failed:
      return 'error';
    case TrainingStatus.Expired:
      return 'error';
    default:
      return 'default';
  }
};

export enum QuestionType {
  Text = 0,
  Number = 1,
  Boolean = 2,
  SingleChoice = 3,
  MultipleChoice = 4,
  Photo = 5,
  Signature = 6,
  Date = 7,
  Rating = 8,
}

export const getQuestionTypeLabel = (type: QuestionType): string => {
  switch (type) {
    case QuestionType.Text:
      return 'Text';
    case QuestionType.Number:
      return 'Number';
    case QuestionType.Boolean:
      return 'Yes/No';
    case QuestionType.SingleChoice:
      return 'Single Choice';
    case QuestionType.MultipleChoice:
      return 'Multiple Choice';
    case QuestionType.Photo:
      return 'Photo';
    case QuestionType.Signature:
      return 'Signature';
    case QuestionType.Date:
      return 'Date';
    case QuestionType.Rating:
      return 'Rating';
    default:
      return 'Unknown';
  }
};

export enum RecurrencePattern {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Annually = 'Annually',
}

export enum DayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum AssignmentStatus {
  Assigned = 'Assigned',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Expired = 'Expired',
}

export enum ActionTriggerType {
  RequireNote = 0,
  RequirePhoto = 1,
  CreateActionItem = 2,
  RequireSignature = 3,
}

export enum TriggerCondition {
  Equals = 0,
  NotEquals = 1,
  LessThan = 2,
  GreaterThan = 3,
  Contains = 4,
}